import React, { useEffect, useState, createContext, useContext } from 'react';
import _ from 'underscore';
import { node } from 'prop-types';

import { useGetCouponDetails } from '@bingads-webui/overreact-cc';
import { useCustomerLevelVariables, usePostponeReadVariables } from '@bingads-webui-campaign-react/basic-context-utils';
import { isProdEnvironment } from '@bingads-webui-campaign-react/smart-page-util';
import { UpSignupWizardCouponClassForNonProd, HasDateExpiredInPST } from '@bingads-webui-campaign-react/mca-core';
import { useIsDraftOrPendingAccount } from '@bingads-webui-campaign-react/smart-page-context';

const VALID_COUPON_CLASS_PROD = 'AENOTINCSPUPQ422US100';

export const COUPON_CLASS = isProdEnvironment(document.domain)
  ? VALID_COUPON_CLASS_PROD
  // Use for SI test to get coupon message displayed
  : UpSignupWizardCouponClassForNonProd;

function useCouponDetail() {
  const [validCouponDetails, setValidCouponDetails] = useState(null);
  const isDraftOfPendingAccount = useIsDraftOrPendingAccount();
  const customerLevelVariables = useCustomerLevelVariables();
  const postponeReadConfig = usePostponeReadVariables();

  const [{ data: couponDetails, error: couponError }, { read: getCouponDetails }]
    = useGetCouponDetails(customerLevelVariables, postponeReadConfig);

  useEffect(() => {
    if (isDraftOfPendingAccount && !couponDetails && !couponError) {
      getCouponDetails({ variables: { ccl: COUPON_CLASS } });
    }
  }, [isDraftOfPendingAccount, couponDetails, couponError, getCouponDetails]);

  useEffect(() => {
    if (_.isArray(couponDetails) && couponDetails.length > 0 && couponDetails[0].CouponDetails) {
      const couponDetail = couponDetails[0].CouponDetails;
      if (!HasDateExpiredInPST(couponDetail.ExpiryDate)) {
        setValidCouponDetails(couponDetail);
      }
    }
  }, [couponDetails]);

  return {
    couponDetails: validCouponDetails,
  };
}

const CouponDetailContext = createContext();
export const useCouponDetailContext = () => useContext(CouponDetailContext);

export function CouponDetailProvider({ children }) {
  const { couponDetails } = useCouponDetail();

  return (
    <CouponDetailContext.Provider value={couponDetails}>
      {children}
    </CouponDetailContext.Provider>
  );
}

CouponDetailProvider.propTypes = {
  children: node.isRequired,
};
